import Vue from 'vue';
import {
    GET_STORE_WORKERS_REQUEST,
    GET_STORE_WORKERS_SUCCESS,
    GET_STORE_WORKERS_FAILURE
} from '../mutationTypes';

const state = {
    loading: false,
    list: [],
};
const mutations = {
    [GET_STORE_WORKERS_REQUEST](state) {
        state.loading = true;
    },
    [GET_STORE_WORKERS_SUCCESS](state, res) {
        state.loading = false;

        state.list = res.masterWorker;
    },
    [GET_STORE_WORKERS_FAILURE](state) {
        state.loading = false;
    },
};

export const actions = {
    async getStoreWorkers({ commit }) {
        commit(GET_STORE_WORKERS_REQUEST);
        const res = await Vue.$ajax.get('getWorkerList');

        if (!res.errorType) {
            commit(GET_STORE_WORKERS_SUCCESS, res);
        } else {
            commit(GET_STORE_WORKERS_FAILURE);
        }
    }
};

export default {
    state,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/workers.js